import { generatePath } from 'react-router-dom'
import { GridCellProps } from '@progress/kendo-react-grid'
import { MarginBonusDetailsKey } from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

import { GridColumn } from './CampaignDetailsResultsPage'

const campaignMarginBonusDetailsResultsColumn: GridColumn[] = [
  {
    field: 'client.name',
    title: MarginBonusDetailsKey.ClientName,
    cell: (props: GridCellProps): JSX.Element => {
      const client = props.dataItem?.client

      if (!client?.id) {
        return <td>{client?.name}</td>
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsClients.detailsUrl as string, {
                id: client.id,
                slug: 'details',
              }),
            }}
            target='_blank'
            rel='noopener noreferrer'
          >
            {client.name}
          </Link>
        </td>
      )
    },
    show: true,
  },
  {
    field: 'tradingAccount.name',
    title: MarginBonusDetailsKey.Account,
    cell: (props: GridCellProps): JSX.Element => {
      const tradingAccount = props.dataItem?.tradingAccount

      if (!tradingAccount?.id) {
        return <td>{tradingAccount?.name}</td>
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsTradingAccounts.detailsUrl as string, {
                id: tradingAccount.id,
                slug: 'details',
              }),
            }}
            target='_blank'
            rel='noopener noreferrer'
          >
            {tradingAccount.name}
          </Link>
        </td>
      )
    },
    show: true,
  },
  {
    field: 'netDeposit',
    title: MarginBonusDetailsKey.NetDeposit,
    show: true,
  },
  {
    field: 'status.name',
    title: MarginBonusDetailsKey.Status,
    show: true,
  },
]

export default campaignMarginBonusDetailsResultsColumn
